export const mq = {
    mobileOnly: '(max-width: 599px)',
    tabletPortraitUp: '(min-width: 600px)',
    tabletLandscapeUp: '(min-width: 900px)',
    desktopUp: '(min-width: 1200px)',
};
